import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/articles';

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}